import { InputRef } from 'antd'
import dayjs from 'dayjs'
import { useCustomInput } from 'shared/libs/hooks/useCustomInput'

import { useRef, useState } from 'react'

import CustomInput from 'shared/ui/Form/CustomInput/CustomInput'
import DatePicker, { DatePickerProps } from 'shared/ui/Form/DatePicker'

import './CustomDatePickerField.css'

export type CustomDatePickerFieldProps = DatePickerProps & {
  wrapperClassname?: string
  placeholderClassname?: string
}

const CustomDatePickerField = ({
  placeholder,
  className,
  value,
  wrapperClassname,
  placeholderClassname,
  ...props
}: CustomDatePickerFieldProps) => {
  const inputRef = useRef<InputRef>(null)
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const { isFocus, setIsFocus, handleBlur, handleFocus } = useCustomInput()

  const changeIsOpen = (isOpen: boolean) => {
    setTimeout(() => {
      setIsOpen(isOpen)
    })
  }

  return (
    <CustomInput
      value={value?.toString()}
      open={() => setIsOpen(true)}
      placeholder={placeholder}
      childrenRef={inputRef}
      wrapperClassname={wrapperClassname}
      placeholderClassname={placeholderClassname}
      isFocus={isFocus}
      setIsFocus={setIsFocus}
    >
      <DatePicker
        open={isOpen}
        onOpenChange={changeIsOpen}
        getPopupContainer={(triggerNode) => triggerNode}
        withPlaceholder={false}
        ref={inputRef}
        value={value && dayjs(value)}
        onBlur={handleBlur}
        onFocus={handleFocus}
        rootClassName={`customDatePicker px-0 py-0 !border-none rounded-[0px] !shadow-none focus:shadow-none focus:border-none w-full ${className}`}
        {...props}
      />
    </CustomInput>
  )
}

export default CustomDatePickerField
